// extracted by mini-css-extract-plugin
module.exports = {"widget":"eligible_widget__3uRXo","title":"eligible_title__1dXT2","bodyContent":"eligible_bodyContent__1QE5t","footer":"eligible_footer__2Wm57","pad":"eligible_pad__2PWu1"};